import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cookie-banner"
}
const _hoisted_2 = { class: "cookie-banner-content" }
const _hoisted_3 = { class: "cookie-text" }
const _hoisted_4 = {
  key: 0,
  class: "cookie-details"
}
const _hoisted_5 = { class: "cookie-category" }
const _hoisted_6 = { class: "cookie-category" }
const _hoisted_7 = { class: "cookie-category" }
const _hoisted_8 = { class: "cookie-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[16] || (_cache[16] = _createElementVNode("h3", null, "🍪 Gestion des cookies", -1)),
            _createElementVNode("p", null, [
              _cache[8] || (_cache[8] = _createTextVNode(" Nous utilisons des cookies pour améliorer votre expérience sur OKOLISY. ", -1)),
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showDetails = !_ctx.showDetails), ["prevent"]))
              }, "En savoir plus")
            ]),
            (_ctx.showDetails)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "cookie-category" }, [
                    _createElementVNode("label", null, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: "",
                        disabled: ""
                      }),
                      _createElementVNode("strong", null, "Cookies nécessaires")
                    ]),
                    _createElementVNode("p", null, "Essentiels au fonctionnement du site.")
                  ], -1)),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tempPreferences.functional) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.tempPreferences.functional]
                      ]),
                      _cache[9] || (_cache[9] = _createElementVNode("strong", null, "Cookies fonctionnels", -1))
                    ]),
                    _cache[10] || (_cache[10] = _createElementVNode("p", null, "Mémorisent vos préférences.", -1))
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tempPreferences.analytics) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.tempPreferences.analytics]
                      ]),
                      _cache[11] || (_cache[11] = _createElementVNode("strong", null, "Cookies analytiques", -1))
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("p", null, "Nous aident à comprendre votre utilisation.", -1))
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tempPreferences.marketing) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.tempPreferences.marketing]
                      ]),
                      _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Cookies marketing", -1))
                    ]),
                    _cache[14] || (_cache[14] = _createElementVNode("p", null, "Pour des publicités personnalisées.", -1))
                  ]),
                  _createElementVNode("button", {
                    class: "btn-save",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSavePreferences && _ctx.handleSavePreferences(...args)))
                  }, " Enregistrer mes préférences ")
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (!_ctx.showDetails)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn-customize",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDetails = true))
                }, " Personnaliser "))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn-refuse",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleRefuse && _ctx.handleRefuse(...args)))
            }, " Refuser "),
            _createElementVNode("button", {
              class: "btn-accept",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleAcceptAll && _ctx.handleAcceptAll(...args)))
            }, " Tout accepter ")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}